import React from 'react';
import { Fade } from 'react-awesome-reveal';
import PageHeader from '../components/PageHeader';
import TestimonialSection from '../components/TestimonialSection';

const Testimonial = () => {
  const breadcrumb = [
    { label: 'Home', href: '/' },
    { label: 'Pages', href: '#' },
    { label: 'Testimonial', href: '/testimonial', active: true }
  ];

  return (
    <>
      <PageHeader title="Testimonial" breadcrumb={breadcrumb} />
      <div className="container-xxl bg-light my-6 py-6 pb-0" style={{ margin: '12rem 0' }}>
        <div className="container">
          <Fade triggerOnce>
            <div className="text-center mx-auto mb-5" style={{ maxWidth: '500px' }}>
              <p className="text-primary text-uppercase mb-2">// Client's Review</p>
              <h1 className="display-6 mb-4">More Than 20000+ Customers Trusted Us</h1>
            </div>
          </Fade>
          <TestimonialSection />
        </div>
      </div>
    </>
  );
};

export default Testimonial;






